import styled from 'styled-components';
import { borderRadius, colorUsage, getSpacing, shadow, typography } from 'stylesheet';
var Container = styled.div.withConfig({
  displayName: "GroupFieldstyle__Container",
  componentId: "sc-ad8cwn-0"
})(["padding:", " ", " ", ";border:1px solid ", ";border-radius:", ";box-shadow:", ";"], getSpacing(4.5), getSpacing(6), getSpacing(3.5), colorUsage.inputBorder, borderRadius.large, shadow.bottom.light);
var TitleContainer = styled.div.withConfig({
  displayName: "GroupFieldstyle__TitleContainer",
  componentId: "sc-ad8cwn-1"
})(["display:flex;align-items:center;"]);
var TitleIconContainer = styled.div.withConfig({
  displayName: "GroupFieldstyle__TitleIconContainer",
  componentId: "sc-ad8cwn-2"
})(["display:flex;align-items:center;& svg > path{width:20px;height:20px;fill:", ";}"], colorUsage.textColor);
var TitleText = styled.p.withConfig({
  displayName: "GroupFieldstyle__TitleText",
  componentId: "sc-ad8cwn-3"
})(["margin-left:", ";", ""], getSpacing(0.5), typography.h3);
export { Container, TitleContainer, TitleText, TitleIconContainer };